import { render } from "./TabEditor.vue?vue&type=template&id=235321e9"
import script from "./TabEditor.vue?vue&type=script&lang=js"
export * from "./TabEditor.vue?vue&type=script&lang=js"
script.render = render

export default script